import { useTranslation } from "react-i18next";
import AutoCompletation from "../../../components/Common/AutoCompletation";
import React, { useRef, useState } from "react"
import { FormGroup } from 'react-bootstrap'
import InventoryMedicationService from "../../../api/Inventory/InventoryMedicationService";
import { CustomDate } from "../../../components/CustomControls/CustomDateTime";
import { ErrorMessage } from "../../../components/Notifications/Notifications";
import { useFormModal } from "../../../components/Modals/formModal.js/FormModal";
import ReleaseList from "./ReleaseList";
import { Tooltip } from "../../../components/Utils/Tooltips";
import { Add, Remove } from "../../../components/Icons/Icons";
import { buildMedicationLabel, isDispenseAddEnabled } from "./inventoryFormRules";
import { QuantityInput } from "./QuantityInput";

export default function DispenseForm({ assignmentType, assignId, handleSubmit, fetchHandler, itemPlaceholder, disabled = false }) {
    const { t } = useTranslation();
    const expirationDateRef = useRef();
    const expirationDateInputRef = useRef();
    const quantityRef = useRef();
    const medicationRef = useRef();
    const [selectedItem, setSelectedItem] = useState(null);
    const [selectedRelease, setSelectedRelease] = useState(null);
    const [quantity, setQuantity] = useState(1);
    const [ReleaseModal, ReleaseActions] = useFormModal({ FormContent: ReleaseList })

    const fetchItems = async (term) => {
        const result = fetchHandler != null
            ? (await fetchHandler(term))
            : (await InventoryMedicationService.Find({ term: term, onlyLocal: true, pageSize: 100 })).Value
        return result
    }

    const handleShowReleaseModal = async () => {
        await ReleaseActions.Show({
            title: t('inventory.commons.lotNumber'),
            onConfirmation: (selected) => setSelectedRelease(selected),
            initValue: { itemId: selectedItem.inventoryItemId, assignmentType: assignmentType, assignId: assignId, includeExpired: false }
        })
    }
    const onCleanSelectedRelease = () => {
        setSelectedRelease(null)
    }

    const curringSelected = (callback) => {
        return (selected) => {
            if (selected != null && selected.length > 0) callback(selected[0])
            else callback(null)
        }
    }

    function isFormValid() {
        return isDispenseAddEnabled({
            hasItem: selectedItem !== null,
            hasRelease: selectedRelease !== null,
            quantity: quantity,
            availableStock: selectedRelease?.stockQuantity
        })
    }
    function handleItemClean() {
        setSelectedItem(null)
        setSelectedRelease(null)
        setQuantity(1)
        medicationRef.current.clear()
    }

    function handleFormSubmit(e) {
        e.preventDefault();

        if (!isFormValid() && handleSubmit !== null) return

        if (selectedRelease.stockQuantity < quantity) {
            ErrorMessage(t('inventory.dispense.errors.cannotOvercomeTheStockQuantity'))
            return;
        }

        handleSubmit({
            item: selectedItem,
            release: selectedRelease,
            assignment: {
                assignmentType: assignmentType
            },
            quantity: quantity,
            availableQuantity: selectedRelease.stockQuantity
        })
        handleItemClean()
        medicationRef.current.focus()
    }

    return (<>
        <form onSubmit={handleFormSubmit} autoComplete="off">
            <div className='input-group-container'>
                <FormGroup style={{ width: "100%" }}>
                    <AutoCompletation
                        id={'medication'}
                        ref={medicationRef}
                        labelKey={(option) => buildMedicationLabel(option)}
                        placeholder={itemPlaceholder ?? t('inventory.dispense.findMedication')}
                        disabled={disabled}
                        fetchOptions={fetchItems}
                        onChange={curringSelected(setSelectedItem)}
                    />
                </FormGroup>
            </div>
            <hr />
            {selectedRelease == null
                && <div className='input-group-container'>
                    <FormGroup style={{ width: "100%" }}>
                        <button className="btn btn-primary" disabled={disabled || selectedItem == null} onClick={_ => handleShowReleaseModal()}>
                            <Tooltip>
                                <Add /> {t('inventory.dispense.selectLotNumber')}
                            </Tooltip>
                        </button>
                    </FormGroup>
                </div>
                || <div className='input-group-container'>
                    <FormGroup style={{ width: "100%" }}>
                        <input disabled={true} value={selectedRelease?.lotNumber} className="rbt-input-main form-control rbt-input" />
                    </FormGroup>

                    <FormGroup style={{ width: "100%" }} >
                        <CustomDate
                            dateRef={expirationDateRef}
                            inputRef={expirationDateInputRef}
                            name={`expirationDate`}
                            onChange={() => { }}
                            onBlur={() => { }}
                            value={selectedRelease?.expirationDate ?? null}
                            defaulValue={null}
                            dateFormat="DD/MM/YYYY"
                            disabled={true}
                            inputProps={{ placeholder: t('commons.expirationDate') }}
                        />
                    </FormGroup>

                    <FormGroup style={{ width: "100%" }}>
                        <button className="btn btn-danger" disabled={disabled || selectedRelease == null} onClick={onCleanSelectedRelease}>
                            <Tooltip tooltip={t('commons.clear')} id={"tooltipedit-limpiarpaciente"}>
                                <span aria-hidden="true"><Remove /></span>
                            </Tooltip>
                        </button>
                    </FormGroup>
                </div>}
            <hr />
            <div style={{ display: "flex", justifyContent: 'end' }} >
                <div style={{ display: 'flex', flexDirection: "column", width: "25%", marginRight: '1rem' }}>
                    <QuantityInput ref={quantityRef}
                        value={quantity}
                        onChange={setQuantity}
                        max={selectedRelease?.stockQuantity}
                        disabled={disabled || selectedRelease == null}
                        placeholder={t('inventory.dispense.quantity')} />
                </div>
                <div style={{ alignSelf: 'self-end' }}>
                    <button type="submit" className='btn btn-success' disabled={disabled || !isFormValid()}>{t('buttons.add')}</button>
                </div>
            </div>
        </form>
        <ReleaseModal />
    </>)
}